import { createCalendarEvent, getFreeBusy } from '../api/communications'
import type { Resolvers } from '../generated/server/resolvers'

const NylasResolver: Resolvers = {
  Query: {
    getFreeBusyTimes: async (_, { start, end, emails }) => {
      return await getFreeBusy(start, end, emails)
    },
  },
  Mutation: {
    createCalendarEvent: async (_, { input }) => await createCalendarEvent(input),
  },
}

export default NylasResolver
